import { Component, Input } from '@angular/core';

import { getFilterSolid, getPathConfig } from '../power-state.utils';

const PATH_SOLAR_TO_GRID = 'M 50 25 Q 50 50 25 50';
const PATH_SOLAR_TO_HOME = 'M 50 25 Q 50 50 75 50';
const PATH_GRID_TO_HOME = 'M 25 50 Q 50 50 75 50';

const PATH_BATTERY_TO_HOME = 'M 50 75 Q 50 50 75 50';
const PATH_GRID_TO_BATTERY = 'M 25 50 Q 50 50 50 75';
const PATH_SOLAR_TO_BATTERY = 'M 50 25 Q 50 50 50 75';

@Component({
  selector: 'app-power-state-mode-two',
  templateUrl: './power-state-mode-two.component.html',
  styleUrls: ['./power-state-mode-two.component.scss'],
})
export class PowerStateModeTwoComponent {

  @Input() bgTextColor = 'white';
  @Input() unitLabel = 'Unit';
  @Input() unitSymbol = 'W';
  @Input() valuePrecision = 0;
  @Input() duration = 1;
  @Input() fontSize = 3;
  @Input() showPowerFlow?: boolean;
  @Input() fromGridToHome?: number;
  @Input() fromSolarToGrid?: number;
  @Input() fromSolarToHome?: number;
  @Input() fromSolarToBattery?: number;
  @Input() fromGridToBattery?: number;
  @Input() fromBatteryToHome?: number;

  readonly PATH_SOLAR_TO_GRID = PATH_SOLAR_TO_GRID;
  readonly PATH_SOLAR_TO_HOME = PATH_SOLAR_TO_HOME;
  readonly PATH_GRID_TO_HOME = PATH_GRID_TO_HOME;

  readonly PATH_BATTERY_TO_HOME = PATH_BATTERY_TO_HOME;
  readonly PATH_GRID_TO_BATTERY = PATH_GRID_TO_BATTERY;
  readonly PATH_SOLAR_TO_BATTERY = PATH_SOLAR_TO_BATTERY;

  readonly getColor = (index: number) => {
    switch (index) {
      case 0:
        // Solar to grid - grid to solar
        return (this.fromSolarToGrid || 0) >= 0 ? 'var(--orange-400)' : 'var(--grey-400)';
      case 1:
        // Solar to home - home to solar
        return (this.fromSolarToHome || 0) >= 0 ? 'var(--orange-400)' : 'var(--blue-500)';
      case 2:
        // grid to home - grid to home
        return (this.fromGridToHome || 0) >= 0 ? 'var(--grey-400)' : 'var(--blue-500)';
      case 3:
        // battery to home - home to battery
        return (this.fromBatteryToHome || 0) >= 0 ? 'var(--green-500)' : 'var(--blue-500)';
      case 4:
        // grid to battery - battery to grid
        return (this.fromGridToBattery || 0) >= 0 ? 'var(--grey-400)' : 'var(--green-500)';
      default:
        // Solar to battery - battery to solar
        return (this.fromSolarToBattery || 0) >= 0 ? 'var(--orange-400)' : 'var(--green-500)';
    }
  };

  readonly getFilterSolid = (color = this.bgTextColor) => getFilterSolid(color);

  readonly getPathConfig = (params: object, duration = this.duration) =>
    getPathConfig(params, duration, { active: false, reverse: false, size: 2 });
}
